"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryItems = [{
  id: 1,
  title: "Moonlit Drift",
  beforeImage: "https://guiding-lionfish.10web.cloud/wp-content/uploads/2026/05/Moonlit-Drift-Album.png?v=9gscgf1xulg",
  description: "A sleep album for those who love nice relaxing album."
}, {
  id: 2,
  title: "Midnight Echoes - EP",
  beforeImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689432/img/midnight_echoes_ep.png",
  description: "The debut EP from Stellar Drift, blending EDM Pop with cinematic textures."
}, {
  id: 3,
  title: "Voltage Rush - Remix",
  beforeImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689432/img/voltage_rush_remix.png",
  description: "High-energy EDM Rock fusion that pushes the boundaries of the genre."
}, {
  id: 4,
  title: "Dust & Diamonds - Single",
  beforeImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689432/img/dust_diamonds_country.png",
  description: "A unique Country Pop anthem with a futuristic electronic twist."
}, {
  id: 5,
  title: "Cyber Pulse - Album",
  beforeImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689432/img/cyber_pulse_album.png",
  description: "The full-length studio experience from Heavens Horizons' flagship artist."
}];
export default function FreshDrops() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="234587" id="fresh-drops" className="w-full bg-background py-20 relative overflow-hidden"></section>;
}